var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconActionDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.917 3.33333H15.8337V5H4.16699V3.33333H7.08366L7.91699 2.5H12.0837L12.917 3.33333ZM6.66699 17.5C5.75033 17.5 5.00033 16.75 5.00033 15.8333V5.83333H15.0003V15.8333C15.0003 16.75 14.2503 17.5 13.3337 17.5H6.66699Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActionDelete);
export default __webpack_public_path__ + "static/media/icon_action_delete.7dea30c5c10250dbc28918db006d1e40.svg";
export { ForwardRef as ReactComponent };